import { render, staticRenderFns } from "./policies.kubewarden.io.clusteradmissionpolicy.vue?vue&type=template&id=edd0561c&scoped=true&"
import script from "./policies.kubewarden.io.clusteradmissionpolicy.vue?vue&type=script&lang=js&"
export * from "./policies.kubewarden.io.clusteradmissionpolicy.vue?vue&type=script&lang=js&"
import style0 from "./policies.kubewarden.io.clusteradmissionpolicy.vue?vue&type=style&index=0&id=edd0561c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd0561c",
  null
  
)

export default component.exports